import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import './AnimatedSection.css';

const AnimatedSection = ({ 
  children, 
  className = '', 
  animationType = 'fadeInUp',
  delay = 0,
  threshold = 0.1 
}) => {
  const [ref, isVisible] = useScrollAnimation(threshold);

  return (
    <div
      ref={ref}
      className={`animated-section ${className} ${isVisible ? 'animate' : ''}`}
      style={{
        animationDelay: `${delay}ms`,
        '--animation-name': animationType
      }}
    >
      {children}
    </div>
  );
};

export default AnimatedSection; 